var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRisingStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 289,
    viewBox: "0 0 275 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.382 158.864C138.268 152.836 103.47 118.038 97.4421 73.9241C97.1681 71.1841 93.058 71.1841 92.51 73.9241C86.756 118.038 51.9581 152.836 7.84406 158.864C5.10406 159.138 5.10406 163.248 7.84406 163.796C51.9581 169.824 86.756 204.348 92.51 248.462C92.784 251.202 96.8941 251.202 97.4421 248.462C103.47 204.348 137.994 169.55 182.108 163.796C185.122 163.248 185.122 159.138 182.382 158.864Z",
    fill: "#D4212F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.556 123.244C221.118 97.2138 241.394 76.6637 267.424 73.3757C269.068 73.1017 269.068 70.6357 267.424 70.3617C241.394 66.7997 220.844 46.5237 217.556 20.4937C217.282 18.8497 214.816 18.8497 214.542 20.4937C210.98 46.5237 190.704 67.0737 164.674 70.3617C163.03 70.6357 163.03 73.1017 164.674 73.3757C190.704 76.9377 211.254 97.2138 214.542 123.244C214.816 124.888 217.282 124.888 217.556 123.244Z",
    fill: "#D4212F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M267.975 246.544C250.713 244.078 237.013 230.652 234.547 213.116C234.273 212.02 232.903 212.02 232.629 213.116C230.163 230.378 216.737 244.078 199.201 246.544C198.105 246.818 198.105 248.188 199.201 248.462C216.463 250.928 230.163 264.354 232.629 281.89C232.903 282.986 234.273 282.986 234.547 281.89C237.013 264.628 250.439 250.928 267.975 248.462C269.071 248.188 269.071 246.818 267.975 246.544Z",
    fill: "#D4212F",
    stroke: "#D4212F",
    strokeWidth: 10.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisingStars);
export default __webpack_public_path__ + "static/media/rising-stars.dee5b2a75bd2b775f2f7d918e5ca8ebc.svg";
export { ForwardRef as ReactComponent };